import { NgModule } from "@angular/core";
import { TransactionDetailsComponent } from './components/transaction-details/transaction-details.component';
import { UiModule } from "../ui/ui.module";

@NgModule({
  imports: [
    UiModule
  ],
  declarations: [
    TransactionDetailsComponent,
  ],
  exports: [
    TransactionDetailsComponent,
  ]
})
export class TransactionModule {}
